import * as Immutable from 'immutable'

export const removeBoldsAndSplitsButLastSplit = (title: string) => {
  if (!title) return ''
  const splits = title.split('|')
  const size = splits.length
  const pagetitle = splits
    .slice(0, size - 1)
    .join('')
    .replace(/\*/g, '')
    .replace(/\s+/g, ' ')
  const sitetitle = splits[size - 1]
  return pagetitle ? [pagetitle, sitetitle].join('|') : sitetitle
}

// Helper for <select> elements
export const toggleLabelFocus = (elementId: string) => {
  const el = document.querySelector(`#${elementId}`)
  el.parentElement.classList.contains('form__select--focus')
    ? el.parentElement.classList.remove('form__select--focus')
    : el.parentElement.classList.add('form__select--focus')
}

export const getSearchParams = (): Immutable.Map<string, string> => {
  if (window.location.search == "") return Immutable.Map()
  let options = window.location.search.slice(1).split("&")
  let kvps = options.map(option => {
    let components = option.split("=")
    let key = components[0].toLowerCase()
    let value = components[1]
    return [key, value]
  })
  return Immutable.Map(kvps)
}

/**
 * Takes as input an iframe and return a json object with the attributes of that iframe
 * Thanks to https://jsfiddle.net/seamusleahy/t6bxt5ax/ ;)
 * @param iframe 
 */
export const get_iframe_props = (iframe: string): object => {
  var leftWhitespaceRe = /^\s+/;
  var input = iframe;
  var parseElMatch = input.match(/^\s*<iframe (.*?)(\/?>|><\/iframe>)\s*$/);
  var attributesRaw = parseElMatch[1];
  var attributesRemaining = attributesRaw.replace(leftWhitespaceRe, '');

  var attrs = {};

  while (attributesRemaining.length > 0) {
    var attrMatch = attributesRemaining.match(/^([\w\-]+)(=("([^"]*)"|'([^']*)'|(\S*)))?/);
    if (attrMatch) {
      attrs[attrMatch[1]] = attrMatch[4] || attrMatch[5] || attrMatch[6] || true;
      attributesRemaining = attributesRemaining.substring(attrMatch[0].length).replace(leftWhitespaceRe, '');
    } else {
      break;
    }
  }
  return attrs;
}

export function ensureSecureUrl(url: string): string {
  return url.replace("http://", "https://")
}

// Temp solution for restoring images that point to the CMS
export const replace_cms_url = (url: string): string => {
  return url.replace('https://vanoord-vanoord-cms.productie.viddadigital.com', `${document.location.origin}/drupal/media`)
    .replace('https://vanoord-vanoord-cms.acceptatie.viddadigital.com', `${document.location.origin}/drupal/media`)
    .replace('https://vanoord-vanoord-cms.test.viddadigital.com', `${document.location.origin}/drupal/media`)
}